export const formatDate = (timestamp: string) => {
  const newDate = new Date(timestamp);
  return `${newDate.toDateString()} ${newDate.toLocaleTimeString()}`;
};
